export const getDialogTitle = (status: string): string => {
  if (status === 'approved') {
    return 'Approve Document'
  }
  if (status === 'rejected') {
    return 'Reject Document'
  }
  return 'Incomplete Document'
}
